module.exports = __webpack_public_path__ + "static/img/Testimonial-blue.a5cb559.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Testimonial-blue.png
// module id = Kw8H
// module chunks = 0